/*
 * spurtcommerce
 * http://www.spurtcommerce.com
 *
 * Copyright (c) 2022 Piccosoft Software Labs Pvt Ltd
 * Author Piccosoft Software Labs Pvt Ltd <support@spurtcommerce.com>
 * Licensed under the MIT license.
 */

import { Action } from '@ngrx/store';
import {type} from '../../../../shared/utility/utilityHelpers';

// model
import { MasterCouponAddModel } from '../models/mastercoupon-Add.model';
import { MasterCouponUpdateModel } from '../models/mastercoupon-Update.model';
import { MasterCouponListModel } from '../models/mastercoupon-list.model';
import { MasterCouponCountModel } from '../models/mastercoupon-count.model';
import { MasterCouponDeleteModel } from '../models/mastercoupon-delete.model';

export const ActionTypes = {
  DO_MASTERCOUPON_UPDATE_ACTION: type('[Coupon] DO_MASTERCOUPON'),
  DO_MASTERCOUPON_UPDATE_SUCCESS: type('[Coupon] DO_MASTERCOUPON_SUCCESS'),
  DO_MASTERCOUPON_UPDATE_FAIL: type('[Coupon] DO_MASTERCOUPON_FAIL'),

  DO_MASTERCOUPON_ADD_ACTION: type('[Coupon] MASTERCOUPON_ACTION'),
  DO_MASTERCOUPON_ADD_SUCCESS: type('[Coupon] MASTERCOUPON_SUCESS'),
  DO_MASTERCOUPON_ADD_FAIL: type('[Coupon] MASTERCOUPON_FAIL'),

  DO_MASTERCOUPON_LIST_ACTION: type('[Coupon] DOMASTERCOUPON'),
  DO_MASTERCOUPON_LIST_SUCCESS: type('[Coupon] DOMASTERCOUPON Success'),
  DO_MASTERCOUPON_LIST_FAIL: type('[Coupon] DOMASTERCOUPON Fail'),

  DO_MASTERCOUPON_COUNT_ACTION: type('[Coupon] DOMASTERCOUPON COUNTACTION'),
  DO_MASTERCOUPON_COUNT_SUCCESS: type('[Coupon] DOMASTERCOUPON COUNTSUCCESS'),
  DO_MASTERCOUPON_COUNT_FAIL: type('[Coupon] DOMASTERCOUPON COUNTFAIL'),

  DO_MASTERCOUPON_DELETE_ACTION: type('[Coupon] DOMASTERCOUPON DELETE_ACTION'),
  DO_MASTERCOUPON_DELETE_SUCCESS: type('[Coupon] DOMASTERCOUPON DELETE_SUCCESS'),
  DO_MASTERCOUPON_DELETE_FAIL: type('[Coupon] DOMASTERCOUPON DELETE_FAIL')
};

// MasterCoupon add 
export class DoAddMasterCouponAction implements Action {
  type = ActionTypes.DO_MASTERCOUPON_ADD_ACTION;

  constructor(public payload: MasterCouponAddModel) {}
}

export class DoAddMasterCouponSuccess implements Action {
  type = ActionTypes.DO_MASTERCOUPON_ADD_SUCCESS;

  constructor(public payload: any) {}
}

export class DoAddMasterCouponFail implements Action {
  type = ActionTypes.DO_MASTERCOUPON_ADD_FAIL;

  constructor(public payload: any = null) {}
}

// MasterCoupon update
export class DoMasterCouponUpdateAction implements Action {
  type = ActionTypes.DO_MASTERCOUPON_UPDATE_ACTION;

  constructor(public payload: MasterCouponUpdateModel) {}
}

export class DoMasterCouponUpdataSuccess implements Action {
  type = ActionTypes.DO_MASTERCOUPON_UPDATE_SUCCESS;

  constructor(public payload: any) {}
}

export class DoMasterCouponUpdateFail implements Action {
  type = ActionTypes.DO_MASTERCOUPON_UPDATE_FAIL;

  constructor(public payload: any = null) {}
}

// MasterCoupon List
export class DOMasterCouponListAction implements Action {
  type = ActionTypes.DO_MASTERCOUPON_LIST_ACTION;

  constructor(public payload: MasterCouponListModel) {}
}

export class DoMasterCouponListSuccess implements Action {
  type = ActionTypes.DO_MASTERCOUPON_LIST_SUCCESS;

  constructor(public payload: any) {}
}

export class DoMasterCouponListFail implements Action {
  type = ActionTypes.DO_MASTERCOUPON_LIST_FAIL;

  constructor(public payload: any = null) {}
}

// MasterCoupon count 
export class DoMasterCouponCountAction implements Action {
  type = ActionTypes.DO_MASTERCOUPON_COUNT_ACTION;

  constructor(public payload: MasterCouponCountModel) {}
}

export class DoMasterCouponCountSuccess implements Action {
  type = ActionTypes.DO_MASTERCOUPON_COUNT_SUCCESS;

  constructor(public payload: any) {}
}

export class DoMasterCouponCountFail implements Action {
  type = ActionTypes.DO_MASTERCOUPON_COUNT_FAIL;

  constructor(public payload: any = null) {}
}

//  MasterCoupon delete
export class MasterCouponDeleteAction implements Action {
  type = ActionTypes.DO_MASTERCOUPON_DELETE_ACTION;

  constructor(public payload: MasterCouponDeleteModel) {}
}

export class MasterCoupondeleteSuccess implements Action {
  type = ActionTypes.DO_MASTERCOUPON_DELETE_SUCCESS;

  constructor(public payload: any) {}
}

export class MasterCouponDeleteFail implements Action {
  type = ActionTypes.DO_MASTERCOUPON_DELETE_FAIL;

  constructor(public payload: any = null) {}
}

export type Actions =
  | DoAddMasterCouponAction
  | DoAddMasterCouponSuccess
  | DoAddMasterCouponFail
  | DoMasterCouponUpdateAction
  | DoMasterCouponUpdataSuccess
  | DoMasterCouponUpdateFail
  | DOMasterCouponListAction
  | DoMasterCouponListSuccess
  | DoMasterCouponListFail
  | DoMasterCouponCountAction
  | DoMasterCouponCountSuccess
  | DoMasterCouponCountFail
  | MasterCouponDeleteAction
  | MasterCoupondeleteSuccess
  | MasterCouponDeleteFail;
